import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

import * as Sentry from '@sentry/browser';

Sentry.init({ dsn: 'https://336d1aa060a94f8f916c1e93d6affab7@o393426.ingest.sentry.io/5244378' });

const instance = axios.create({
    headers: {
        common: {
            authorization: ''
        }
    }
});

const encuestasModule = {
    state: {
        encuestas: []
    },
    getters: {
        getEncuestas: state => state.encuestas
    },
    actions: {
        requestEncuestas({ commit, dispatch, getters }) {


            let urls = {
                "empresa" : "/api/empresa/dameEncuestas/", 
                "empleo" : "/api/Alumno/dameEncuestas/", 
                "practicas" : "/api/Alumno/dameEncuestas/", 
            }

            return new Promise((resolve, reject) => {

                axios.get(urls[getters.getusertype]+'1').then(result => {

                    if (result.data.status == 0) {

                        if (result.data.datos.numPaginas != 1) {
                            let data = {
                                max: result.data.datos.numPaginas,
                                page: 2,
                                url : urls[getters.getusertype]
                            }
                            dispatch('requestMoreEncuestas', data);
                        }
                        commit('addEncuestas', result.data.datos.encuestas);
                        resolve(true);

                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }

                }).catch(error => {

                });
            });
        },
        requestMoreEncuestas({ commit, dispatch }, data) {

            return new Promise((resolve, reject) => {

                if (data.page <= data.max) {

                    axios.get(data.url + data.page).then(result => {

                        if (result.data.status == 0) {
                            commit('addEncuestas', result.data.datos.encuestas);
                            data.page++;
                            dispatch('requestMoreEncuestas', data);
                            resolve(true);
                        } else {
                            commit('setError', result.data.status)
                            reject(false);
                        }

                    }).catch(error => {

                    });

                } else {
                    resolve(true)
                }
            });
        },
        requestLoginEncuestas: ({ commit, dispatch }, logindata) => {

            let urls = {
                'encuestaquery': "/api/encuestas/accesoEncuesta",
                "encuestaanonimo" : "/api/encuestas/logaInvitado",
                "PrivadoEncuesta" : "/api/encuestas/logaUsuario"
            };

            let urllogin = urls[logindata.eAmbito] + '/' + logindata.urlAcceso;


            return new Promise((resolve, reject) => {


                instance.post(urllogin, logindata).then(response => {

                    let result = response.data;

                    if (result.status == 0) {

                        let data = result.datos;

                        window.localStorage.setItem('_tokenencuesta', data.token);

                        commit("setLoggedEncuesta");

                        if (!!data.token) {
                            resolve(true);
                        } else {
                            reject(data);
                        }

                    } else {

                        (!!result.status) ? commit('setError', result.status) : null;
                        reject(false);
                    }

                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestEncuesta({ commit }, id) {

            return new Promise((resolve, reject) => {

                instance.get('/api/Encuestas/' + id).then(result => {
                    if (result.data.status == 0) {
                        resolve(result.data.datos);
                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                        Sentry.captureException(JSON.stringify(result.data));
                    }

                }).catch(error => {
                    reject(false);
                    Sentry.captureException(error);
                });
            });
        },
        sendrespuestas({ commit }, data) {

            let values = {
                lContestaciones : data.respuestas
            }

            return new Promise((resolve, reject) => {

                instance.post('/api/encuestas/guardaContestacionEncuesta'+'/'+data.urlAcceso,values).then(result => {
                    if (result.data.status == 0) {
                        resolve(true);
                        commit('setError', 612)
                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                        Sentry.captureException(err);
                    }

                }).catch(error => {

                });
            });
        },
    },
    mutations: {
        addEncuestas(state, encuestas) {
            state.encuestas = state.encuestas.concat(encuestas);
        },
        setLoggedEncuesta(state) {
            instance.defaults.headers.common['authorization'] = `Bearer ${window.localStorage.getItem('_tokenencuesta')}`;
        }
    }
}

export default encuestasModule;


// WEBPACK FOOTER //
// ./src/store/encuestasModule.js